import { Auth0ContextInterface } from '@auth0/auth0-react';
import { useEffect } from 'react';

type HandleAuthRedirectProps = {
  isInMaintenanceMode?: boolean;
  auth0UserLoading: boolean;
  auth0UserAuthenticated: boolean;
  loginWithRedirect: Auth0ContextInterface['loginWithRedirect'];
  auth0Error?: Error;
  isEmbedded?: boolean;
};

export const useHandleAuthRedirect = ({
  isInMaintenanceMode,
  auth0UserLoading,
  auth0UserAuthenticated,
  loginWithRedirect,
  auth0Error,
  isEmbedded,
}: HandleAuthRedirectProps) => {
  useEffect(() => {
    if (isInMaintenanceMode) {
      return;
    }
    // Skip redirect in embedded contexts - embedded auth is handled by useDestroyExistingSSOSession
    if (isEmbedded) {
      return;
    }
    if (!auth0UserLoading && !auth0UserAuthenticated && !auth0Error) {
      loginWithRedirect({
        appState: {
          returnTo: `${window.location.pathname}${window.location.search}`,
        },
      });
    }
  }, [
    auth0UserLoading,
    auth0UserAuthenticated,
    loginWithRedirect,
    auth0Error,
    isInMaintenanceMode,
    isEmbedded,
  ]);
};
